import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';
import { AvatarComponent, IconComponent } from '@copado/cds';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    IconComponent,
    NgbDropdownModule,
    NgbTooltipModule,
    NgClass,
    NgTemplateOutlet,
  ],
  selector: 'app-switcher',
  styleUrl: './switcher.component.scss',
  templateUrl: './switcher.component.html',
})
export class SwitcherComponent<T> {
  avatar = input<null | string>();
  title = input<string>();
  subTitle = input<null | string>();
  empty = input<string>();
  items = input<T[]>([]);
  itemTemplate = input.required<TemplateRef<unknown>>();
  maxHeight = input('50vh');
  minHeight = input('0');
  maxWidth = input('400px');
  minWidth = input('0');
  select = output<T>();
  open = output<boolean>();

  isCollapsed = input<boolean>();
}
